import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import {WINDOW, NAVIGATOR} from '../../constants/environment'
import './styles.css';

/**
 *  BreadcrumbNavigation
 */
class BreadcrumbNavigation extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    links: PropTypes.arrayOf(PropTypes.shape({
      pageName: PropTypes.string,
      pcText: PropTypes.string,
      mbText: PropTypes.string,
      href: PropTypes.string,
      external: PropTypes.bool
    }))
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    links: null
  };
  
  constructor(props) {
    super();
    this.props = props;

    this.state = {
      didMount: false
    };
  }

  componentDidMount() {

    WINDOW.onresize = this.onResize;

    this.setPosition();

    this.setDevice();

    this.setState({
      didMount: true
    });
  }

  onResize = (e) => {
    this.setPosition();
  };

  setPosition = () => {
    const container = this.refs.container;
    const list = this.refs.list;
    const containerWidth = container.getBoundingClientRect().width;
    let totalWidth = 0;

    for(let i = 0; i < list.childNodes.length; i++){
      let child = list.childNodes[i];
      totalWidth += child.getBoundingClientRect().width;
    }

    container.classList.remove('BreadcrumbNavigation__container--overflow');
    if(containerWidth < totalWidth){
      container.classList.add('BreadcrumbNavigation__container--overflow');
    }

    
  };

  setDevice = () => {
    if(NAVIGATOR){
      let ua = NAVIGATOR.userAgent;
      if(ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0){
        return;
      }else if(ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0){
        const container = this.refs.container;
        const list = this.refs.list;
        const containerWidth = container.getBoundingClientRect().width;
        let totalWidth = 0;
    
        for(let i = 0; i < list.childNodes.length; i++){
          let child = list.childNodes[i];
          totalWidth += child.getBoundingClientRect().width;
        }

        container.classList.add('BreadcrumbNavigation__container--tablet');
    
        if(containerWidth < totalWidth){
          container.scrollLeft = totalWidth - containerWidth;
        }
      }
    }
  }
  
  render() {
    const {
      containerId,
      containerClass,
      anchorPoint,
      anchorName,
      links
    } = this.props;
    
    //
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
        anchorPoint={anchorPoint}
        anchorName={anchorName}
      >
        <div className='BreadcrumbNavigation'>
          <div className='BreadcrumbNavigation__container' ref='container'>
            <ul className='BreadcrumbNavigation__container__list' ref='list'>
              {links.map((link, index) => {
                let pcText;
                // let pcText, mbText;
                pcText = link.pcText != null && link.pcText !== '' ? link.pcText : link.pageName;
                // mbText = link.mbText != null && link.mbText !== '' ? link.mbText : (link.pcText != null && link.pcText !== '' ? link.pcText : link.pageName);
                pcText = pcText.split('|').join('');
                // mbText = mbText.split('|').join('');
                return (
                  <li
                    key={index}
                    className={"BreadcrumbNavigation__container__list__item"}
                  >
                    <a className='BreadcrumbNavigation__container__list__item__link' href={link.href} target={link.external === true ? '_blank' : null}>
                      <span className="BreadcrumbNavigation__container__list__item__link__text">{pcText}</span>
                      {/*<span className="BreadcrumbNavigation__container__list__item__link__text BreadcrumbNavigation__container__list__item__link__text--pc">{pcText}</span>*/}
                      {/*<span className="BreadcrumbNavigation__container__list__item__link__text BreadcrumbNavigation__container__list__item__link__text--mb">{mbText}</span>*/}
                    </a>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
        <script type="application/ld+json">
          {(() => {
            if(this.state.didMount){
              let json = {
                "@context": "http://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": []
              };
              let list = [];
              for(let i = 0; i < links.length; i++){
                let link = links[i];
                let text = link.pcText != null && link.pcText !== '' ? link.pcText : link.pageName;
                text = text.split('|').join('');
                let url = WINDOW.location.protocol + '//' + WINDOW.location.hostname + link.href;
                let obj = {
                  "@type": "ListItem",
                  "position": i+1,
                  "item": {
                    "@id": url,
                    "name": text
                  }
                }
                list.push(obj);
              }
              json["itemListElement"] = list;
              return(JSON.stringify(json))
            }
          })()}
        </script>
      </Wrapper>
    )
  }
  
}

export default BreadcrumbNavigation;



// WEBPACK FOOTER //
// ./src/containers/breadcrumb-navigation/index.jsx